<template>

    <section class="hero-wrap section pt-lg-5 pt-2 min-vh-100">
        <div class="hero-bg" style="background-size: cover;background: url('/img/Curve Line.svg') no-repeat;"></div>
        <div class="hero-content">
            <div class="container">
                <div style="border: 1px solid rgba(255, 255, 238, 0.17)" class="rounded-lg py-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-5">
                            <div class="bg-white shadow-lg p-4 rounded-lg">
                                <form @submit.prevent="runForm" autocomplete="off">
                                    <div class="text-center w-75 m-auto">
                                        <h4 class="text-dark-50 text-center mt-0 font-weight-bold">Sign In</h4>
                                        <p class="text-muted mb-3">Enter your email address and password to login</p>
                                    </div>
                                    <p v-if="message"
                                       :class="['alert text-center mb-0 rounded-0 mb-3 px-3' , error ? 'alert-danger' : 'alert-success bg-primary text-white']">
                                        {{ message }}
                                    </p>
                                    <div>
                                        <div class="form-group">
                                            <label>Email address</label>
                                            <input type="text" v-model="form.email"
                                                   :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your email" autocomplete="unique-1">
                                            <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group mb-3">
                                            <a href="/password/reset" class="text-primary float-right"><small>Forgot
                                                your
                                                password?</small></a>
                                            <label>Password</label>
                                            <input type="password" v-model="form.password"
                                                   :class="[ 'form-control' , form.errors.get('password') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your password" autocomplete="unique-2">
                                            <div v-text="form.errors.get('password')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group mb-0 text-center">
                                            <button @click.prevent="loginUser"
                                                    :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']"
                                                    type="submit">Login
                                            </button>
                                        </div>
                                        <div class="small text-black-50 mt-2">
                                            New here?
                                            <router-link to="/auth/register">Sign up</router-link>
                                            instead?
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import Form from "../../../core/forms/form";

export default {
    name: "auth-login",
    data: function () {
        return {
            prevRoute: null,
            loading: false,
            error: false,
            message: '',
            form: new Form({
                email: '',
                password: '',
            })
        };
    },
    methods: {
        runForm() {
            this.loginUser();
        },
        loginUser() {
            this.loading = true;
            this.error = false;
            this.message = "";

            const returnUrl = this.prevRoutePath

            this.form.submit('/admin/login').then((response) => {
                if (response.data.success === true) {
                    this.message = response.data.message;
                    setTimeout(function () {
                        window.location = `${window.location.origin}` + returnUrl;
                    }, 2000);
                } else {
                    this.message = response.data.message;
                    this.loading = false;
                    this.error = true;
                }
            }).catch((error) => {
                this.loading = false;
            });
        }
    },
    metaInfo: {title: 'Login'},
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },
    computed: {
        prevRoutePath() {
            return this.prevRoute ? this.prevRoute.path : '/'
        },
    }
}
</script>
